import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import Vue3Storage from "vue3-storage";


createApp(App).use(Vue3Storage).use(Quasar, quasarUserOptions).use(store).use(router).mount('#app')
